import React from 'react';
import { LegalDocPage } from './LegalDocPage';

export const DPAPage: React.FC = () => {
  return (
    <LegalDocPage
      docId="dpa"
      title="Accord de traitement des données (DPA)"
      updatedAt="—"
    />
  );
};
